import { trackPageView } from "./analytics";
import AboutPage from "./pages/about/page";
import CareerPage from "./pages/career/page";
import ContactPage from "./pages/contact/page";
import EmployeesPage from "./pages/employees/page";
import HomePage from "./pages/home/page";
import NaasPage from "./pages/naas/page";
import OfferPage from "./pages/offer/page";
import TopBar from "./components/topbar";

import { Helmet } from "react-helmet";

import { useState, useEffect } from "react";

import useWindowSize from "./utils/windowsize";
import Footer1 from "./components/footer1";

function App() {
  const windowSize = useWindowSize();

  useEffect(() => {
    // initGA(); // Initiera Google Analytics
    trackPageView(window.location.pathname + window.location.search); // Spåra startsida
  }, []);

  useEffect(() => {
    const sections = document.querySelectorAll(".section");
    const observerOptions = {
      root: null, // Observatören ser hela viewport
      threshold: 0.5, // Minst 50% av sektionen ska vara synlig
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const sectionId = entry.target.id;
          // Uppdatera URL:en med den synliga sektionen utan att ladda om sidan
          window.history.replaceState(null, null, `#${sectionId}`);
        }
      });
    }, observerOptions);

    sections.forEach((section) => observer.observe(section));

    return () => {
      sections.forEach((section) => observer.unobserve(section));
    };
  }, []);

  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="Acebit - Vi är bäst i Sverige på att designa, bygga och arbeta med moderna nätverk."
        />
        <title>
          Acebit - Vi är bäst i Sverige på att designa, bygga och arbeta med
          moderna nätverk.
        </title>
      </Helmet>
      <div className="bg-slate-200 dark:bg-gray3">
        <TopBar windowSize={windowSize} />
        <div className="flex flex-col sm:gap-y-0 gap-y-32">
          <HomePage />
          <div className="flex flex-col items-center sm:gap-0 gap-y-48">
            <AboutPage />
            <OfferPage />
            <NaasPage />
            <CareerPage />
            <EmployeesPage />
            <ContactPage />
          </div>
        </div>
        <Footer1 />
      </div>
    </>
  );
}

export default App;
